import Component from 'vue-class-component'
import IconButton from '@/components/buttons/richmenu/IconButton';

@Component({
  name: 'strikethrough-button',
})
export default class StrikethroughButton extends IconButton {
}
